import { render } from "./AddEditFranchise.vue?vue&type=template&id=6cdc154d"
import script from "./AddEditFranchise.vue?vue&type=script&lang=js"
export * from "./AddEditFranchise.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__